// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19262e0d","864":"acf43e81"}[chunkId] + ".chunk.js";
};